import {
   StyledSubHeader,
   StyledSubHeaderControl,
   StyledSubHeaderControlContainer,
   StyledSubHeaderGroup,
   StyledSubHeaderLabel,
   StyledSubHeaderSection,
   StyledSubHeaderTabContainer
} from 'shared/styled/SubHeader.styled';
import SubHeaderTab from 'components/SubHeaderTab';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { DateTime } from 'luxon';

interface NewNearMissSubHeaderProps {
   formHasErrors: boolean;
   goToOverview: () => void;
}

const NewNearMissSubHeader = ({ formHasErrors, goToOverview }: NewNearMissSubHeaderProps) => {
   const { t } = useTranslation();

   const displayDateTime = (): string => {
      let dateString = new Date();
      
      const dt = DateTime.fromJSDate(dateString).setLocale(i18next.language);
      return dt.toLocaleString({...DateTime.DATETIME_MED_WITH_WEEKDAY});
   };

   return (
      <StyledSubHeader>
         <StyledSubHeaderSection style={{ maxWidth: '25%' }}>
            <StyledSubHeaderGroup>
               <StyledSubHeaderControlContainer>
                  <StyledSubHeaderLabel>{t('ObservationPage.IncidentDate')}</StyledSubHeaderLabel>
                  <StyledSubHeaderControl>{displayDateTime()}</StyledSubHeaderControl>
               </StyledSubHeaderControlContainer>
            </StyledSubHeaderGroup>
            <StyledSubHeaderGroup>
               <StyledSubHeaderControlContainer>
                  <StyledSubHeaderLabel>{t('ObservationList.Status')}</StyledSubHeaderLabel>
                  <StyledSubHeaderControl>{t('ObservationPage.New')}</StyledSubHeaderControl>
               </StyledSubHeaderControlContainer>
            </StyledSubHeaderGroup>
         </StyledSubHeaderSection>
         <StyledSubHeaderSection style={{ flex: '2 1 auto' }}>
            <StyledSubHeaderGroup style={{ justifyContent: 'flex-end' }}>
               <StyledSubHeaderTabContainer>
                  <SubHeaderTab
                     onClick={goToOverview}
                     isActive={true}
                     display={t('ObservationPage.Overview')}
                     highlightErrors={formHasErrors}
                  />
               </StyledSubHeaderTabContainer>
            </StyledSubHeaderGroup>
         </StyledSubHeaderSection>
      </StyledSubHeader>
   );
};

export default NewNearMissSubHeader;
